import _objectSpread from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/objectSpread2.js";
import { mapState } from 'vuex';
export default {
  data: function data() {
    return {
      isShow: false,
      tabList: [],
      visible: false,
      timer: null
    };
  },
  watch: {
    isShow: function isShow(val) {
      if (val) {
        this.$emit('hide', true);
      } else {
        this.$emit('hide', false);
      }
    },
    $route: function $route() {
      this.isShow = false;
      this.$emit('hide', false);
    }
  },
  computed: _objectSpread({}, mapState({
    categoryTree: 'categoryTree'
  })),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    handleMouseEnter: function handleMouseEnter(item) {
      var _this = this;
      this.timer = setTimeout(function () {
        _this.tabList = item.childrenList;
        _this.isShow = true;
        _this.timer = null;
      }, 300);
    },
    handleMouseLeave: function handleMouseLeave(item) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    handleLink: function handleLink(item) {
      this.addTrack('category_click', {
        categoryId: item.id,
        categoryName: item.cateName || item.cateAlias,
        userId: this.$store.state.userInfo.userId,
        timeField: 'operateTime'
      });
    }
  }
};